module.exports = __webpack_public_path__ + "img/guillermo.1f54ac8b.png";